/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text, Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import RTE from '@consteed/frontend/components/pageDesigner/RTE'

/**
 * MainBanner component
 *
 * @param {object} props
 * @param {image} - props.image - Image.
 * @param {string} - props.heading - Text Overlay.
 * @returns {React.ReactElement} - Main Banner component.
 */
export const MainBanner = ({image, heading = ''}) => {
    return (
        <Box className={'pdcOuterBox pdcFullWidth'}>
            <Flex
                backgroundImage={image?.url}
                backgroundSize={'cover'}
                backgroundRepeat={'no-repeat'}
                backgroundPosition={'63% 50%'}
                minHeight={'411px'}
                width={'100%'}
                alignItems={'end'}
            >
                {heading !== '' && (
                    <Box width={'100%'} paddingBottom={8}>
                        <Box className={'pdcOuterBox'}>
                            <div className={'decorationLine'}></div>
                        </Box>
                        <Text color={'white'}>
                            <RTE
                                richText={heading}
                                textStyles={{base: 'book3Xlarge', xl: 'book6Xlarge'}}
                                sx={{
                                    p: {
                                        textStyle: {base: 'bookLarge', lg: 'book2Xlarge'}
                                    }
                                }}
                            />
                        </Text>
                    </Box>
                )}
            </Flex>
        </Box>
    )
}

MainBanner.propTypes = {
    image: PropTypes.shape({
        _type: PropTypes.string,
        focalPoint: PropTypes.shape({
            _type: PropTypes.string,
            x: PropTypes.number,
            y: PropTypes.number
        }),
        metaData: PropTypes.shape({
            _type: PropTypes.string,
            height: PropTypes.number,
            width: PropTypes.number
        }),
        url: PropTypes.string,
        src: PropTypes.string || PropTypes.object
    }).isRequired,
    heading: PropTypes.string
}

export default MainBanner
